// extracted by css-extract-rspack-plugin
var _1 = "QtPoy8QzypcwNJNl";
export { _1 as "stack" }
// extracted by css-extract-rspack-plugin
var _1 = "QtPoy8QzypcwNJNl";
export { _1 as "stack" }
